import RFIDrawingModal from 'components/modals/RFIDrawingModal';
import React from 'react';
import { ModalState } from 'records/ModalState';
import { SheetVersion } from 'records/SheetVersion';
import { getPageThumbnailUrl } from 'services/pageService';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';

interface Props extends WithAppStoreProps {
  sheetVersion: SheetVersion;
}

interface State {
  loaded: boolean;
  url: string;
}

class RFIOverlayAttachedDrawing extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.loadThumbnail();
  }

  state = {
    loaded: false,
    url: '',
  };

  loadThumbnail = async (): Promise<void> => {
    const { sheetVersion } = this.props;

    const url = await getPageThumbnailUrl(
      sheetVersion.documentid,
      sheetVersion.pageid
    );

    this.setState({ loaded: true, url });
  };

  handleSheetClick = (): void => {
    const { actions, sheetVersion } = this.props;

    const modalState = new ModalState({
      id: 'RFIDrawingModal',
      portal: 'main',
      open: true,
      component: RFIDrawingModal,
      props: {
        sheetVersion,
      },
    });

    actions.createModal(modalState);
  };

  render(): React.ReactNode {
    const { sheetVersion } = this.props;
    const { loaded, url } = this.state;

    return (
      <div
        className="b-radius-2 oh hrem-7p5 wrem-7p5 bgd-gray-3 mr2 shrink-0 cursor-pointer"
        title={sheetVersion.sheetnumber}
        onClick={this.handleSheetClick}
      >
        {loaded ? (
          <img
            className="h100 w100 of-contain"
            alt={sheetVersion.pageid}
            src={url}
          />
        ) : null}
      </div>
    );
  }
}

export default withAppStore<Props>(RFIOverlayAttachedDrawing);
